/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Copilot_Disabled_DescriptionInputs */



/**
* | output |
* | --- |
* | "Please enable compliance in settings to use the compliance copilot." |
*
* @param {Compliance_Copilot_Disabled_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_copilot_disabled_description = /** @type {((inputs?: Compliance_Copilot_Disabled_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Copilot_Disabled_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte aktivieren Sie Compliance in den Einstellungen, um den Compliance-Copiloten zu nutzen.")
	return /** @type {LocalizedString} */ ("Please enable compliance in settings to use the compliance copilot.")
});